import { render, staticRenderFns } from "./gene-report-apply-list.vue?vue&type=template&id=a017ae00&"
import script from "./gene-report-apply-list.vue?vue&type=script&lang=js&"
export * from "./gene-report-apply-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports